import {getCurrentYear} from '../../utils/commons'
import DiyToolBestPicksLogo from './logo'
import {diyToolBestPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'diytoolbestpicks' as const,
  domainType: 'picks' as const,
  siteName: 'DIY Tool Best Picks',
  logo: <DiyToolBestPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/diytoolbestpicks.png',
  styles: diyToolBestPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-50BW5Z2LPF',
    camelCaseUrl: 'DIYToolBestPicks.com',
    title: (_category: string, count: string) =>
      `Top ${count} DIY Tools ${getCurrentYear()} in the US | DIYToolBestPicks.com – Reviews & Expert Insights`,
    description: (_category?: string, _count?: string) =>
      `Choose the best DIY tools with expert reviews and side-by-side comparisons. Find top-rated hand and power tools for any project with confidence`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
